unit CommodityPriceSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.DBCtrls, WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client;

type
  TfrmCommodityPriceSetup = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebDBEdit1: TDBEdit;
    WebDBDateTimePicker1: TDBDateTimePicker;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebButton1: TButton;
    WebButton2: TButton;
    wcCommodityPrices: TXDataWebClient;
    wdsCommodityPrices: TXDataWebDataSet;
    wdsCommodityPricesAUTONO: TIntegerField;
    wdsCommodityPricesCommoditiesno: TIntegerField;
    wdsCommodityPricesENDDATE: TStringField;
    wdsCommodityPricesCOSTPRICE: TFloatField;
    wdsCommodityPricesCONFIREMED: TStringField;
    dsCommodityPrices: TDataSource;
    wdsCommodityPricesSTARTDATE: TDateField;
    procedure WebFormShow(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
  private
    { Private declarations }
    procedure loadCommodityPrice;
  public
    { Public declarations }
    iState , iPriceNo , iCommodityNo : Integer;
  protected procedure LoadDFMValues; override; end;

var
  frmCommodityPriceSetup: TfrmCommodityPriceSetup;

implementation

{$R *.dfm}

uses
  stfmssystem.connection, share.common, share.classes;

procedure TfrmCommodityPriceSetup.loadCommodityPrice;
var
  ComodityPriceListParams : TComodityPriceListParams;
  sJsonParams : String;

  procedure OnError(Error: TXDataClientError);
    begin
      loadCommodityPrice;
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          loadCommodityPrice;
        end
      else
        begin
          wdsCommodityPrices.Close;
          wdsCommodityPrices.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsCommodityPrices.Open;
        end;
    end;
begin

  ComodityPriceListParams := TComodityPriceListParams.Create;
  ComodityPriceListParams.AutoNo := iPriceNo;
  ComodityPriceListParams.PageCount := -1;
  ComodityPriceListParams.CommoditiesNo := iCommodityNo;
  ComodityPriceListParams.Confirmed := '*';

  sJsonParams := ConvertObjToJson(ComodityPriceListParams).ToJSON;
  console.log(sJsonParams);

   wcCommodityPrices.RawInvoke('IstfmsloadsService.Get_CommodityPriceList_View',[sJsonParams],@OnSuccess,@OnError);
end;

procedure TfrmCommodityPriceSetup.WebButton1Click(Sender: TObject);
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);

    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('Commodity Successfully saved.');
      Close;
    end;
begin
  wdsCommodityPrices.FieldByName('Commoditiesno').AsInteger := iCommodityNo;

  case iState of
    1:  Begin
          console.log(GetJsonFromDataSet(wdsCommodityPrices));

          wcCommodityPrices.RawInvoke('IstfmsloadsService.Put_CommodityPriceList_Insert',[GetJsonFromDataSet(wdsCommodityPrices)],@OnSuccess,@OnError);
        End;
    2:  Begin
          wcCommodityPrices.RawInvoke('IstfmsloadsService.Put_CommodityPriceList_Edit',[GetJsonFromDataSet(wdsCommodityPrices)],@OnSuccess,@OnError);
        End;
  end;
end;

procedure TfrmCommodityPriceSetup.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmCommodityPriceSetup.WebFormShow(Sender: TObject);
begin

  case iState of
    1:  Begin
          wdsCommodityPrices.Open;
          wdsCommodityPrices.Insert;
        End;
    2:  Begin
          loadCommodityPrice;
        End;
  end;

end;

procedure TfrmCommodityPriceSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  WebDBDateTimePicker1 := TDBDateTimePicker.Create(Self);
  wcCommodityPrices := TXDataWebClient.Create(Self);
  wdsCommodityPrices := TXDataWebDataSet.Create(Self);
  wdsCommodityPricesAUTONO := TIntegerField.Create(Self);
  wdsCommodityPricesCommoditiesno := TIntegerField.Create(Self);
  wdsCommodityPricesENDDATE := TStringField.Create(Self);
  wdsCommodityPricesCOSTPRICE := TFloatField.Create(Self);
  wdsCommodityPricesCONFIREMED := TStringField.Create(Self);
  wdsCommodityPricesSTARTDATE := TDateField.Create(Self);
  dsCommodityPrices := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBDateTimePicker1.BeforeLoadDFMValues;
  wcCommodityPrices.BeforeLoadDFMValues;
  wdsCommodityPrices.BeforeLoadDFMValues;
  wdsCommodityPricesAUTONO.BeforeLoadDFMValues;
  wdsCommodityPricesCommoditiesno.BeforeLoadDFMValues;
  wdsCommodityPricesENDDATE.BeforeLoadDFMValues;
  wdsCommodityPricesCOSTPRICE.BeforeLoadDFMValues;
  wdsCommodityPricesCONFIREMED.BeforeLoadDFMValues;
  wdsCommodityPricesSTARTDATE.BeforeLoadDFMValues;
  dsCommodityPrices.BeforeLoadDFMValues;
  try
    Name := 'frmCommodityPriceSetup';
    Width := 480;
    Height := 255;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 480;
    WebPanel1.Height := 255;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 24;
    WebLabel1.Top := 103;
    WebLabel1.Width := 50;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Start date';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 264;
    WebLabel2.Top := 103;
    WebLabel2.Width := 53;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Cost Price';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 480;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Commodity Price Setup';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 195;
    WebPanel3.Width := 480;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 24;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Save';
    WebButton1.Color := clGreenyellow;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 152;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebDBEdit1.SetParentComponent(WebPanel1);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 264;
    WebDBEdit1.Top := 124;
    WebDBEdit1.Width := 145;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 2;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.Text := 'WebDBEdit1';
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'COSTPRICE';
    WebDBEdit1.DataSource := dsCommodityPrices;
    WebDBDateTimePicker1.SetParentComponent(WebPanel1);
    WebDBDateTimePicker1.Name := 'WebDBDateTimePicker1';
    WebDBDateTimePicker1.Left := 24;
    WebDBDateTimePicker1.Top := 124;
    WebDBDateTimePicker1.Width := 170;
    WebDBDateTimePicker1.Height := 22;
    WebDBDateTimePicker1.BorderStyle := bsSingle;
    WebDBDateTimePicker1.ChildOrder := 3;
    WebDBDateTimePicker1.Color := clWhite;
    WebDBDateTimePicker1.Date := 45974.698018692130000000;
    WebDBDateTimePicker1.Role := '';
    WebDBDateTimePicker1.Text := '';
    WebDBDateTimePicker1.DataField := 'STARTDATE';
    WebDBDateTimePicker1.DataSource := dsCommodityPrices;
    wcCommodityPrices.SetParentComponent(Self);
    wcCommodityPrices.Name := 'wcCommodityPrices';
    wcCommodityPrices.Connection := dmData.dbConnect;
    wcCommodityPrices.Left := 44;
    wcCommodityPrices.Top := 50;
    wdsCommodityPrices.SetParentComponent(Self);
    wdsCommodityPrices.Name := 'wdsCommodityPrices';
    wdsCommodityPrices.Connection := dmData.dbConnect;
    wdsCommodityPrices.Left := 148;
    wdsCommodityPrices.Top := 50;
    wdsCommodityPricesAUTONO.SetParentComponent(wdsCommodityPrices);
    wdsCommodityPricesAUTONO.Name := 'wdsCommodityPricesAUTONO';
    wdsCommodityPricesAUTONO.FieldName := 'AUTONO';
    wdsCommodityPricesCommoditiesno.SetParentComponent(wdsCommodityPrices);
    wdsCommodityPricesCommoditiesno.Name := 'wdsCommodityPricesCommoditiesno';
    wdsCommodityPricesCommoditiesno.FieldName := 'Commoditiesno';
    wdsCommodityPricesENDDATE.SetParentComponent(wdsCommodityPrices);
    wdsCommodityPricesENDDATE.Name := 'wdsCommodityPricesENDDATE';
    wdsCommodityPricesENDDATE.FieldName := 'ENDDATE';
    wdsCommodityPricesCOSTPRICE.SetParentComponent(wdsCommodityPrices);
    wdsCommodityPricesCOSTPRICE.Name := 'wdsCommodityPricesCOSTPRICE';
    wdsCommodityPricesCOSTPRICE.FieldName := 'COSTPRICE';
    wdsCommodityPricesCONFIREMED.SetParentComponent(wdsCommodityPrices);
    wdsCommodityPricesCONFIREMED.Name := 'wdsCommodityPricesCONFIREMED';
    wdsCommodityPricesCONFIREMED.FieldName := 'CONFIREMED';
    wdsCommodityPricesSTARTDATE.SetParentComponent(wdsCommodityPrices);
    wdsCommodityPricesSTARTDATE.Name := 'wdsCommodityPricesSTARTDATE';
    wdsCommodityPricesSTARTDATE.FieldName := 'STARTDATE';
    dsCommodityPrices.SetParentComponent(Self);
    dsCommodityPrices.Name := 'dsCommodityPrices';
    dsCommodityPrices.DataSet := wdsCommodityPrices;
    dsCommodityPrices.Left := 252;
    dsCommodityPrices.Top := 50;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBDateTimePicker1.AfterLoadDFMValues;
    wcCommodityPrices.AfterLoadDFMValues;
    wdsCommodityPrices.AfterLoadDFMValues;
    wdsCommodityPricesAUTONO.AfterLoadDFMValues;
    wdsCommodityPricesCommoditiesno.AfterLoadDFMValues;
    wdsCommodityPricesENDDATE.AfterLoadDFMValues;
    wdsCommodityPricesCOSTPRICE.AfterLoadDFMValues;
    wdsCommodityPricesCONFIREMED.AfterLoadDFMValues;
    wdsCommodityPricesSTARTDATE.AfterLoadDFMValues;
    dsCommodityPrices.AfterLoadDFMValues;
  end;
end;

end.